export const InstallSymbolsJson = {
  P: {
    color: 'inactive',
    margin: '0 - Z2',
    childProps: {
      display: 'inline'
    },
    children: [
      '2. Create ',
      {
        Labeled: {
          text: 'symbols.json'
        }
      },
      ' file in your project:'
    ]
  },
  CodePreviewWithTitle: {
    margin: 'Z1 0 0',
    Title: null,
    value: (el) => {
      const rootState = el.getRootState?.()
      const framework =
        rootState?.framework === 'domql' ? 'symbols' : rootState?.framework || 'symbols'
      return `{
  "key": "${el.getAppKey?.() || 'my-app'}",
  "framework": "${framework}",
  "packageManager": "${rootState?.pkgManager || 'npm'}"
}`
    }
  }
}
